import React from "react";
import axios from "axios";
import { PrintButton } from "../../components/printButton";
import { t } from "../../localization/localization";

import { Line } from "react-chartjs-2";

export default class OUPubCountByYears extends React.Component {
  state = {
    data: [],
  };

  componentDidMount() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const crisId = urlSearchParams.get("crisId");
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/org-unit/${crisId}/pubCountByYears`
      )
      .then((res) => {
        this.setState({
          data: res.data
            .sort((e1, e2) => e1.year - e2.year)
            .map((e) => {
              return { label: e.year, data: e.count };
            }),
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    return (
      <div style={{ width: 440, height: 320, margin: "auto" }}>
        <PrintButton />
        <Line
          data={{
            labels: this.state.data.map((e) => e.label),
            datasets: [
              {
                label: t(locale, "/ou/pubCountByYears/title"),
                fill: false,
                lineTension: 0.1,
                backgroundColor: "rgba(0, 31, 84, 0.4)",
                borderColor: "rgba(0, 31, 84, 1)",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                pointBorderColor: "rgba(0, 31, 84, 1)",
                pointBackgroundColor: "#fff",
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "rgba(0, 31, 84, 1)",
                pointHoverBorderColor: "rgba(220,220,220,1)",
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: this.state.data.map((e) => e.data),
              },
            ],
          }}
          width={440}
          height={320}
          options={{
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                display: false,
              },
            },
          }}
        />
      </div>
    );
  }
}
